import {LocationRoute} from "./locationconfig";

export enum KnownRoutes {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Amex = 'amex',
  AmexEcom = 'amex_ecom',
  AmexF2FDirect = 'amex_f2f_direct',
  Maestro = 'maestro',
  Discover = 'discover',
  DCI = 'dci',
  JCB = 'jcb',
  UPI = 'upi',
}

export function getTargetSchemes(existingRoutes: LocationRoute[], addAmexIfNotExisting: boolean): KnownRoutes[] {
  const primarySchemes = [KnownRoutes.Visa, KnownRoutes.Mastercard, KnownRoutes.Maestro, KnownRoutes.JCB, KnownRoutes.UPI, KnownRoutes.DCI];
  let amexScheme = KnownRoutes.Amex;
  if (existingRoutes.findIndex((lr) => lr.scheme == KnownRoutes.AmexEcom.toString()) >= 0) {
    amexScheme = KnownRoutes.AmexEcom
  }
  const includeAmex = addAmexIfNotExisting || existingRoutes.findIndex((lr) => lr.scheme == KnownRoutes.Amex.toString() || lr.scheme == KnownRoutes.AmexEcom.toString()) >= 0;
  return includeAmex
    ? [...primarySchemes, amexScheme]
    : primarySchemes;
}
